import { Bell } from 'lucide-react';
import { Button } from '../ui/button';
import { UserDropdown } from './UserDropdown';
import { Breadcrumbs } from './Breadcrumbs';

export function Header() {
  return (
    <header className="bg-card border-b border-border shadow-sm sticky top-0 z-40">
      <div className="flex items-center justify-between px-8 py-5 gap-4">
        <div className="flex items-center gap-4 min-w-0 flex-1">
          <Breadcrumbs />
        </div>

        <div className="flex items-center gap-3 sm:gap-4 flex-shrink-0">
          {/* Notifications */}
          <div className="relative">
            <Button variant="ghost" size="icon" className="relative hover:bg-neutral-100 rounded-xl">
              <Bell className="w-5 h-5" />
              {/* Notification badge */}
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-error rounded-full ring-2 ring-white" />
              <span className="sr-only">Уведомления</span>
            </Button>
          </div>

          {/* User Dropdown */}
          <UserDropdown />
        </div>
      </div>
    </header>
  );
}